export default __webpack_public_path__ + "static/media/icon-dashboard.737e7a44.svg";